import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import FormFieldTitle from 'components/shared/admin/forms/form-field-title'
import UploaderField from 'forms/shared/fields/uploader-preview'

const ImagesFields = ({ form }) => {
  return (
    <>
      <FormFieldTitle title={`VENUE IMAGES`} />
      <div className="my-3">
        <UploaderField
          form={form}
          name={'images'}
          resize={true}
          apiRoute={`/upload/attachment/`}
          acceptedFiles="image/jpg, image/jpeg, image/png"
        />
      </div>
    </>
  )
}

ImagesFields.propTypes = {
  form: PropTypes.string.isRequired,
  venue: PropTypes.object,
  images: PropTypes.array,
}

const mapStateToProps = ({ venue }) => {
  return {
    venue,
    images: venue.details.images,
  }
}

export default connect(mapStateToProps)(ImagesFields)
